import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Carousel as BootstrapCarousel, CarouselCaption, CarouselIndicators, CarouselItem } from 'reactstrap';
import Background1 from '../../../../images/custom_organization/img-background1.jpg';
import Background2 from '../../../../images/custom_organization/img-background2.jpg';
import Background3 from '../../../../images/custom_organization/img-background3.jpg';
import Background4 from '../../../../images/custom_organization/img-background4.jpg';
import './carousel.scss';

export const Carousel = () => {
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [animating, setAnimating] = useState<boolean>(false);
    const { t } = useTranslation();

    const items = [
        {
            src: Background1,
            altText: 'Slide 1',
            captionHeader: t('login.carousel.first')
        },
        {
            src: Background2,
            altText: 'Slide 2',
            captionHeader: t('login.carousel.second')
        },
        {
            src: Background4,
            altText: 'Slide 4',
            captionHeader: t('login.carousel.third.start'),
            captionText: t('login.carousel.third.end')
        },
        {
            src: Background3,
            altText: 'Slide 3',
            captionHeader: t('login.carousel.fourth')
        }
    ];

    const next = () => {
        if (animating) return;
        const nextIndex = (activeIndex + 1) % items.length;
        setActiveIndex(nextIndex);
    };

    const previous = () => {
        if (animating) return;
        const nextIndex = (activeIndex + items.length - 1) % items.length;
        setActiveIndex(nextIndex);
    };

    const goToIndex = (newIndex: number) => {
        if (animating) return;
        setActiveIndex(newIndex);
    };

    const slides = items.map(item => {
        return (
            <CarouselItem onExiting={() => setAnimating(true)} onExited={() => setAnimating(false)} key={item.src}>
                <div className="carousel--item" style={{ backgroundImage: `url(${item.src})` }} />
                <CarouselCaption captionText={item.captionText ?? ''} captionHeader={item.captionHeader ?? ''} />
            </CarouselItem>
        );
    });

    return (
        <div className="carousel--color">
            <BootstrapCarousel activeIndex={activeIndex} next={next} previous={previous} interval={5000}>
                <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} />
                {slides}
            </BootstrapCarousel>
        </div>
    );
};

export default Carousel;
